import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; // On réutilise le style du Login

const SignupPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: '', // Initialiser le champ
        usage_type: 'Architecte' // Valeur par défaut
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

    const USAGE_OPTIONS = [
        "Architecte",
        "Etudiant",
        "Designer",
        "Architecture d'interieur",
        "Paysagiste",
        "Urbaniste",
        "Autre"
    ];

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        // 1. Check all fields are filled
        if (!formData.username || !formData.email || !formData.password || !formData.confirmPassword) {
            setError("Veuillez remplir tous les champs.");
            setLoading(false);
            return;
        }

        // 2. Check Password Length
        if (formData.password.length < 8) {
            setError("Le mot de passe doit contenir au moins 8 caractères.");
            setLoading(false);
            return;
        }

        // 3. Check Special Character
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        if (!specialCharRegex.test(formData.password)) {
            setError("Le mot de passe doit contenir au moins un caractère spécial.");
            setLoading(false);
            return;
        }

        // 4. Check Passwords Match
        if (formData.password !== formData.confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
            setLoading(false);
            return;
        }

        try {
            // Note: Le backend attendra 'usage_type' qui sera traité par le CustomRegisterSerializer
            // dj-rest-auth attend 'password1' et 'password2'
            const payload = {
                username: formData.username,
                email: formData.email,
                password: formData.password,
                usage_type: formData.usage_type
            };

            await axios.post(`${API_URL}/api/register/`, payload);
            setSuccess(true);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data) {
                // Récupérer le premier champ en erreur
                const errorEntries = Object.entries(err.response.data);
                if (errorEntries.length > 0) {
                    const [field, messages] = errorEntries[0];
                    const msg = Array.isArray(messages) ? messages[0] : messages;

                    // Mapping des noms de champs
                    const fieldNames = {
                        username: "Nom d'utilisateur",
                        email: "Email",
                        password: "Mot de passe",
                        confirmPassword: "Confirmation du mot de passe",
                        usage_type: "Type d'usage",
                        non_field_errors: "Erreur"
                    };
                    const fieldName = fieldNames[field] || field;

                    // Traduction des messages courants
                    let displayMsg = msg;
                    if (msg === "This field is required.") {
                        displayMsg = "Ce champ est requis.";
                    } else if (msg.includes("A user with that username already exists")) {
                        displayMsg = "Ce nom d'utilisateur est déjà pris.";
                    } else if (msg.includes("Enter a valid email address")) {
                        displayMsg = "Adresse email invalide.";
                    } else if (msg.includes("user with this email address already exists")) {
                        displayMsg = "Un compte existe déjà avec cet email.";
                    }

                    setError(`${fieldName} : ${displayMsg}`);
                } else {
                    setError("Erreur inconnue lors de l'inscription.");
                }
            } else {
                setError("Erreur serveur. Veuillez réessayer.");
            }
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="login-container">
                <div className="login-card">
                    <h1 className="login-title">Vérification Requise</h1>
                    <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                        Votre compte a été créé.<br />
                        Un code de vérification a été envoyé à <strong>{formData.email}</strong>.
                    </p>
                    <button onClick={() => navigate('/verify-email')} className="login-btn">
                        Saisir le code
                    </button>
                    <p style={{ fontSize: '0.9rem', marginTop: '10px', color: '#666' }}>
                        Le code est valide pendant 24h.
                    </p>
                </div>
            </div>
        );
    }

    // SVG Icons
    const EyeOpen = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
        </svg>
    );

    const EyeClosed = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>
    );

    return (
        <div className="login-container">
            <div className="simple-nav">
                <button className="brand-home-link" onClick={() => navigate('/')}>ARCHIVIZAI</button>
            </div>
            <div className="login-card">
                <h1 className="login-title">Essai Gratuit</h1>
                {/* Subtitle removed as requested */}

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="usage_type">Vous êtes ?</label>
                        <select
                            id="usage_type"
                            className="input-field"
                            value={formData.usage_type}
                            onChange={handleChange}
                            style={{ backgroundColor: 'white' }}
                        >
                            {USAGE_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>

                    <div className="input-group">
                        <label htmlFor="username">Nom d'utilisateur</label>
                        <input
                            type="text"
                            id="username"
                            className="input-field"
                            placeholder="Pseudo"
                            value={formData.username}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            className="input-field"
                            placeholder="votre@email.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Mot de passe</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                className="input-field"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                minLength={8}
                                style={{ width: '100%', paddingRight: '40px', boxSizing: 'border-box' }}
                            />
                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#000',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {showPassword ? <EyeOpen /> : <EyeClosed />}
                            </button>
                        </div>
                    </div>

                    <div className="input-group">
                        <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                className="input-field"
                                placeholder="••••••••"
                                value={formData.confirmPassword || ''}
                                onChange={handleChange}
                                required
                                style={{ width: '100%', paddingRight: '40px', boxSizing: 'border-box' }}
                            />
                            <button
                                type="button"
                                onClick={toggleConfirmPasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#000',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {showConfirmPassword ? <EyeOpen /> : <EyeClosed />}
                            </button>
                        </div>
                    </div>

                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Création...' : 'Démarrer l\'essai gratuit'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>Déjà un compte ? <button onClick={() => navigate('/connexion')} className="link-btn">Se connecter</button></p>
                </div>
            </div >
        </div >
    );
};

export default SignupPage;
